import { TableSchool } from '@/shared/type';
import { ResponseSchool } from '@/shared/types/entities/School';

const nullToEmpty = (startDate: string | null, endDate: string | null) => {
  if (startDate || endDate) {
    return `${startDate || ''} ~ ${endDate || ''}`;
  } else {
    return '';
  }
};

export const toTableSchools = (schools: ResponseSchool[]): TableSchool[] => {
  const parsed = schools.map((school) => {
    const forcedDisabled = school.forced_disabled === 1;
    return {
      id: school.organization_id,
      name: school.organization_name,
      rehearsalDate: nullToEmpty(
        school.rehearsal_startdate_at,
        school.rehearsal_enddate_at,
      ),
      productionDate: nullToEmpty(
        school.production_startdate_at,
        school.production_enddate_at,
      ),
      information: school.downloaded === 1 ? 'DL済' : '',
      status: forcedDisabled ? '強制非公開中' : school.status,
      isEnabled: school.is_enabled ? '有効' : '無効',
      type: '県立高等学校 県立中学・中等教育学校',
      forcedDisabled,
      rehearsalUploaded: school.rehearsal_uploaded === 1,
      productionUploaded: school.production_uploaded === 1,
      documentUploaded: school.document_uploaded === 1,
    };
  });
  return parsed;
};

type RequestSortType =
  | 'organization_name'
  | 'rehearsal_startdate_at'
  | 'production_startdate_at';

export const toRequestSchoolKey = (
  tableSchoolKey: keyof TableSchool,
): RequestSortType | undefined => {
  switch (tableSchoolKey) {
    case 'name':
      return 'organization_name';
    case 'rehearsalDate':
      return 'rehearsal_startdate_at';
    case 'productionDate':
      return 'production_startdate_at';
    default:
      return undefined;
  }
};

export const arrayToRequestString = (value: unknown[]) => {
  return value.join(',');
};
